import { CalendarDays } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ConnectProviderButtons } from './ConnectProviderButtons';

export function IntegrationsEmptyState() {
  const { t } = useTranslation('calendar');

  return (
    <div
      className="flex flex-col items-center gap-4 rounded-lg border border-dashed border-border py-12 px-6 text-center"
      data-testid="settings-integrations-empty"
    >
      <CalendarDays className="size-10 text-muted-foreground" aria-hidden="true" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-foreground">{t('integrations.empty.title')}</p>
        <p className="text-sm text-muted-foreground max-w-md">
          {t('integrations.empty.description')}
        </p>
      </div>
      <ConnectProviderButtons />
    </div>
  );
}
